import { FileOpenRounded } from '@mui/icons-material'
import classNames from 'classnames'
import { AppealStatus, TAppealOffer, TServiceOffer } from 'feature/appeals/type'
import { Button } from 'ui'

import { OfferPriceBlock } from '../OfferPriceBlock/OfferPriceBlock'

import style from './OfferPaymentDefaultInf.module.scss'

type TOfferPaymentDefaultInf = {
  offer: TServiceOffer
  isDeclined: boolean | undefined
  isOfferActive: boolean
  hasApprovedOrder: boolean | undefined
  recalculateHandler: () => void
  approveOfferHandler: () => void
  status: TAppealOffer['status'] | undefined
  recalcInProgress: boolean
  appealStatus: AppealStatus | null
}

// блок с кнопкой перерасчера КП в статусах !== approved
export const OfferPaymentDefaultInf = ({
  offer,
  isDeclined,
  isOfferActive,
  hasApprovedOrder,
  recalculateHandler,
  approveOfferHandler,
  status,
  recalcInProgress,
  appealStatus,
}: TOfferPaymentDefaultInf) => {
  const { offerUrl, price } = offer

  const isButtonsVisible =
    price > 0 && !hasApprovedOrder && !isDeclined && !recalcInProgress

  return (
    <>
      {offerUrl && !hasApprovedOrder && (
        <Button
          // @ts-ignore
          to={offerUrl}
          startIcon={<FileOpenRounded color='primary' />}
          variant='contained'
          color='secondary'
          className={style.openCheck}
          data-testid='offer-open-btn'
        >
          Открыть коммерческое предложение
        </Button>
      )}

      {price > 0 && !isDeclined && (
        <OfferPriceBlock offer={offer} appealStatus={appealStatus} />
      )}

      {price === 0 && (
        <div className={style.price}>
          <span className='default-text'>
            Скоро здесь появится возможность выбрать и оплатить коммерческое
            предложение.
          </span>
        </div>
      )}

      {recalcInProgress && (
        <div className={style.price}>
          <span className='default-text'>
            Производится перерасчет данных. После актуализации данных Вы сможете
            произвести оплату коммерческого предложения
          </span>
        </div>
      )}

      {isButtonsVisible && (
        <div className={style.buttonsWrapper}>
          {status === 'SENT' && (
            <Button
              onClick={approveOfferHandler}
              variant='contained'
              color='primary'
              disabled={!isOfferActive}
              className={classNames(style.openCheck, style.openCheckPaid)}
              data-testid='offer-approve-btn'
            >
              Выбрать для оплаты
            </Button>
          )}

          {!isOfferActive && (
            <Button
              onClick={recalculateHandler}
              variant='contained'
              color='primary'
              className={classNames(style.openCheck, style.openCheckPaid)}
              data-testid='offer-recalc-btn'
            >
              Пересчитать
            </Button>
          )}
        </div>
      )}
    </>
  )
}
